import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/43.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Bułkę z herbatą"
            question="Dokąd idziesz dalej?"
            audio={audio}
            answers={{
                ans1: "Na mały rynek.",
                ans2: "Na długi rynek.",
                ans3: "Do karczmy pani Jasińskiej."
            }}
            links={{
                link1: PAGES.p83,
                link2: PAGES.p84,
                link3: PAGES.p87
            }}
            content={
                <div>
                    <ul>
                        <li>Bułeczka z herbatką raz – uśmiecha się kobieta. Przy stole zagaduje do ciebie Stefan.</li>
                        <li>Ej, ty – mówi, a na jego chudej, żółtej twarzy pojawia się coś w rodzaju rumieńca. – Jesteś w porządku. Trzymaj się! – dorzuca i odchodzi do znajomych gęsiarzy.</li>
                    </ul>
                </div>
            }
        />

    );
}